import { connect, DataItem, getDataClass } from 'scrivito'

import { DataItemLink } from '@/Atomic/Atoms/DataItemLink'
import {
  getDataItemTitle,
  getEntityIconElement,
  getEntityIconElementByEntity,
} from '@/utils/dataClassMap'
import { ensureString } from '@/utils/ensureString'
import { getDisplayValue } from '@/utils/getDisplayValue'

interface SearchResultItemProps {
  searchResult: DataItem
  hideSearchResults: () => void
}

export const SearchResultsItem = connect(function SearchResultsItem({
  searchResult,
  hideSearchResults,
}: SearchResultItemProps) {
  const dataClassName = ensureString(searchResult.get('entity'))
  const dataClass = getDataClass(dataClassName)
  const targetItem = dataClass?.get(searchResult.id()) ?? null

  return (
    <DataItemLink dataItem={targetItem} onClick={hideSearchResults}>
      <div className="jr-list-item">
        <div className="jr-list-group shrink">
          {getIcon(searchResult, targetItem)}
        </div>
        <div className="jr-list-group grow">
          <p className="h5 mb-0">
            {getDisplayValue({
              rawValue: getDataItemTitle(searchResult),
            })}
          </p>
        </div>
      </div>
    </DataItemLink>
  )
})

const iconConfig = {
  avatarSize: 'lg' as const,
  className: 'me-3',
}

const getIcon = (dataItem: DataItem, targetItem: DataItem | null) => {
  if (targetItem) {
    return getEntityIconElement(targetItem, iconConfig)
  }

  return getEntityIconElementByEntity(dataItem, iconConfig)
}
